import type {RecordCollectionItem} from 'typings/portaro.be.types';

export const REMOVE_EVENT_TYPE = 'removeItem' as const;
export const MOVE_UP_EVENT_TYPE = 'moveUpItem' as const;
export const MOVE_DOWN_EVENT_TYPE = 'moveDownItem' as const;

export interface RecordCollectionItemEventMap {
    [REMOVE_EVENT_TYPE]: RecordCollectionItemEventDetail;
    [MOVE_UP_EVENT_TYPE]: RecordCollectionItemEventDetail;
    [MOVE_DOWN_EVENT_TYPE]: RecordCollectionItemEventDetail;
}

export interface RecordCollectionItemEventDetail {
    item: RecordCollectionItem;
}

export interface RecordCollectionItemEvent extends CustomEvent {
    detail: RecordCollectionItemEventDetail;
}